<app-spinner></app-spinner>
<div>
  <div class="modal-header rb-modal-header">
    <h4 class="modal-title font-weight-bold text-black-1">{{ title_tag }}</h4>
  </div>
  <div class="modal-body">
    <div class="row mt-3">
      <div class="col-4">
        <label for="first_name" class="text-black-1">Select Test Type</label>
      </div>
      <div class="input-group col-8">
        <form [formGroup]="selectTestForm">
          <p-dropdown
            class="w-100-p"
            [options]="CognitiveTestType"
            optionLabel="name"
            optionValue="value"
            (onChange)="selectQuestionType($event)"
            formControlName="testType"
            placeholder="Select question type."
          ></p-dropdown>
        </form>
      </div>
    </div>
    <div *ngIf="selectTestForm.get('testType').value === 'go-no-go'">
      <form [formGroup]="cognitiveFormGoNoGO">
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Name</label>
          </div>
          <div class="input-group col-8">
            <input class="form-control rb-input" placeholder="Name" type="text" formControlName="cognitiveTestName" />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (goNoGoformControl.cognitiveTestName.touched || submitted) && goNoGoformControl.cognitiveTestName.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="goNoGoformControl.cognitiveTestName.errors.required"
              >Required</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Description</label>
          </div>
          <div class="input-group col-8">
            <textarea class="form-control" formControlName="cognitiveTestDescription" placeholder="Description">
            </textarea>
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (goNoGoformControl.cognitiveTestDescription.touched || submitted) &&
              goNoGoformControl.cognitiveTestDescription.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="goNoGoformControl.cognitiveTestDescription.errors.required"
              >Required</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Max Duration of Test in Seconds</label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="Max Duration of Test"
              type="number"
              formControlName="goNoGoDuration"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="(goNoGoformControl.goNoGoDuration.touched || submitted) && goNoGoformControl.goNoGoDuration.errors"
          >
            <label for="name" class="text-danger" *ngIf="goNoGoformControl.goNoGoDuration.errors.required"
              >Required</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Number of Go’s </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="Number of Go’s"
              formControlName="noOfGoes"
              type="number"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="(goNoGoformControl.noOfGoes.touched || submitted) && goNoGoformControl.noOfGoes.errors"
          >
            <label for="name" class="text-danger" *ngIf="goNoGoformControl.noOfGoes.errors.required">Required</label>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Number of No Go’s</label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="Number of No Go’s"
              formControlName="noOfNoGoes"
              type="number"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="(goNoGoformControl.noOfNoGoes.touched || submitted) && goNoGoformControl.noOfNoGoes.errors"
          >
            <label for="name" class="text-danger" *ngIf="goNoGoformControl.noOfNoGoes.errors.required">Required</label>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Duration of the error message in milliseconds </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="Duration of the error message"
              formControlName="errorMsgDuration"
              type="number"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (goNoGoformControl.errorMsgDuration.touched || submitted) && goNoGoformControl.errorMsgDuration.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="goNoGoformControl.errorMsgDuration.errors.required"
              >Required</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label class="text-black-1" translate>User groups</label>
          </div>
          <div class="col-8">
            <fui-multi-select
              [style]="{ width: '100%' }"
              class="selection"
              formControlName="groupIds"
              [options]="userGroupsOptins"
              labelField="name"
              valueField="uuid"
              [isSearchable]="true"
              [showCountText]="'Select'"
              #multiSelect
            >
              <fui-select-option *ngFor="let option of multiSelect.filteredOptions" [value]="option">
              </fui-select-option>
            </fui-multi-select>
            <div
              class="col-12 error-mssg"
              *ngIf="(goNoGoformControl.groupIds.touched || submitted) && goNoGoformControl.groupIds.errors"
            >
              <label for="isactive" class="text-danger" *ngIf="goNoGoformControl.groupIds.errors.required">
                *Please select user group.
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="isactive" class="text-black-1" translate>Cognitive status</label>
          </div>
          <div class="input-group col-8">
            <p-dropdown
              class="w-100-p"
              [options]="cognitiveStatus"
              optionLabel="name"
              optionValue="value"
              formControlName="isActive"
              placeholder="Select Cognitive status."
            ></p-dropdown>
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="(goNoGoformControl.isActive.touched || submitted) && goNoGoformControl.isActive.errors"
          >
            <label for="isactive" class="text-danger" *ngIf="goNoGoformControl.isActive.errors.required">
              *Please select survey status.
            </label>
          </div>
        </div>
      </form>
    </div>
    <div *ngIf="selectTestForm.get('testType').value === 'cognitive-pvt'">
      <form [formGroup]="cognitiveFormPvt">
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Name</label>
          </div>
          <div class="input-group col-8">
            <input class="form-control rb-input" placeholder="Name" type="text" formControlName="cognitiveTestName" />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="(pvtformControl.cognitiveTestName.touched || submitted) && pvtformControl.cognitiveTestName.errors"
          >
            <label for="name" class="text-danger" *ngIf="pvtformControl.cognitiveTestName.errors.required"
              >Required</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Description</label>
          </div>
          <div class="input-group col-8">
            <textarea class="form-control" formControlName="cognitiveTestDescription" placeholder="Description">
            </textarea>
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (pvtformControl.cognitiveTestDescription.touched || submitted) &&
              pvtformControl.cognitiveTestDescription.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="pvtformControl.cognitiveTestDescription.errors.required"
              >Required</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Max Duration of Test in Seconds</label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="Please enter Max Duration of Test in Seconds"
              type="number"
              formControlName="testDurationPvt"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="(pvtformControl.testDurationPvt.touched || submitted) && pvtformControl.testDurationPvt.errors"
          >
            <label for="name" class="text-danger" *ngIf="pvtformControl.testDurationPvt.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Duration between each timer min in seconds </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="Duration between each timer min in seconds"
              type="number"
              formControlName="eachTimerBetweenMinPvt"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (pvtformControl.eachTimerBetweenMinPvt.touched || submitted) &&
              pvtformControl.eachTimerBetweenMinPvt.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="pvtformControl.eachTimerBetweenMinPvt.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Duration between each timer max seconds</label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="Duration between each timer max in seconds"
              type="number"
              formControlName="eachTimerBetweenMaxPvt"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (pvtformControl.eachTimerBetweenMaxPvt.touched || submitted) &&
              pvtformControl.eachTimerBetweenMaxPvt.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="pvtformControl.eachTimerBetweenMaxPvt.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"
              >Duration to wait and abort when there’s no response in seconds</label
            >
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="Duration to wait and abort when there’s no response in seconds"
              type="number"
              formControlName="abortDurationPvt"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="(pvtformControl.abortDurationPvt.touched || submitted) && pvtformControl.abortDurationPvt.errors"
          >
            <label for="name" class="text-danger" *ngIf="pvtformControl.abortDurationPvt.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label class="text-black-1" translate>User groups</label>
          </div>
          <div class="col-8">
            <fui-multi-select
              [style]="{ width: '100%' }"
              class="selection"
              formControlName="groupIds"
              [options]="userGroupsOptins"
              labelField="name"
              valueField="uuid"
              [isSearchable]="true"
              [showCountText]="'Select'"
              #multiSelect
            >
              <fui-select-option *ngFor="let option of multiSelect.filteredOptions" [value]="option">
              </fui-select-option>
            </fui-multi-select>
            <div
              class="col-12 error-mssg"
              *ngIf="(pvtformControl.groupIds.touched || submitted) && pvtformControl.groupIds.errors"
            >
              <label for="isactive" class="text-danger" *ngIf="pvtformControl.groupIds.errors.required">
                *Please select user group.
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="isactive" class="text-black-1" translate>Cognitive status</label>
          </div>
          <div class="input-group col-8">
            <p-dropdown
              class="w-100-p"
              [options]="cognitiveStatus"
              optionLabel="name"
              optionValue="value"
              formControlName="isActive"
              placeholder="Select Cognitive status."
            ></p-dropdown>
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="(pvtformControl.isActive.touched || submitted) && pvtformControl.isActive.errors"
          >
            <label for="isactive" class="text-danger" *ngIf="pvtformControl.isActive.errors.required">
              *Please select survey status.
            </label>
          </div>
        </div>
      </form>
    </div>
    <div *ngIf="selectTestForm.get('testType').value === 'gamblinf'">
      <form [formGroup]="cognitiveFormGambling">
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Name</label>
          </div>
          <div class="input-group col-8">
            <input class="form-control rb-input" placeholder="Name" type="text" formControlName="cognitiveTestName" />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.cognitiveTestName.touched || submitted) &&
              gamblingFormControl.cognitiveTestName.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.cognitiveTestName.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Description</label>
          </div>
          <div class="input-group col-8">
            <textarea class="form-control" formControlName="cognitiveTestDescription" placeholder="Description">
            </textarea>
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.cognitiveTestDescription.touched || submitted) &&
              gamblingFormControl.cognitiveTestDescription.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.cognitiveTestDescription.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Total trials</label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="Total trials"
              type="number"
              formControlName="totalTrialGambling"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.totalTrialGambling.touched || submitted) &&
              gamblingFormControl.cognitiveTestDescription.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.cognitiveTestDescription.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"> Initial Amount</label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="Initial Amount"
              type="number"
              formControlName="initalAmoutGambling"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.initalAmoutGambling.touched || submitted) &&
              gamblingFormControl.initalAmoutGambling.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.initalAmoutGambling.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"> Deck1 : Gain Amout </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="E.g. 100"
              type="number"
              formControlName="noOfGainDecOne"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.noOfGainDecOne.touched || submitted) && gamblingFormControl.noOfGainDecOne.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.noOfGainDecOne.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"> Deck1 : Loss Amount </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="E.g. 100"
              type="number"
              formControlName="noOfLossDecOne"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.noOfLossDecOne.touched || submitted) && gamblingFormControl.noOfLossDecOne.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.noOfLossDecOne.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"> Deck1 : Loss Percentage </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="E. g.40%"
              min="0"
              max="100"
              type="number"
              formControlName="noOfLossPercentageDecOne"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.noOfLossPercentageDecOne.touched || submitted) &&
              gamblingFormControl.noOfLossPercentageDecOne.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.noOfLossPercentageDecOne.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"> Deck2 : Gain Amount </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="E.g. 200"
              type="number"
              formControlName="noOfGainDecTwo"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.noOfGainDecTwo.touched || submitted) && gamblingFormControl.noOfGainDecTwo.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.noOfGainDecTwo.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"> Deck2: Loss Amount </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="E.g. 100"
              type="number"
              formControlName="noOfLossDecTwo"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.noOfLossDecTwo.touched || submitted) && gamblingFormControl.noOfLossDecTwo.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.noOfLossDecTwo.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"> Deck2: Percentage of Loss </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="E.g. 40%"
              min="0"
              max="100"
              type="number"
              formControlName="noOfLossPercentageDecTwo"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.noOfLossPercentageDecTwo.touched || submitted) &&
              gamblingFormControl.noOfLossPercentageDecTwo.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.noOfLossPercentageDecTwo.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"> Deck3 : Gain Amount </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="E.g. 200"
              type="number"
              formControlName="noOfGainDecThree"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.noOfGainDecThree.touched || submitted) && gamblingFormControl.noOfGainDecThree.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.noOfGainDecThree.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"> Deck3: Loss Amount </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="E.g. 100"
              type="number"
              formControlName="noOfLossDecThree"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.noOfLossDecThree.touched || submitted) && gamblingFormControl.noOfLossDecThree.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.noOfLossDecThree.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"> Deck3: Percentage of Loss </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="E.g. 50 %"
              type="number"
              min="0"
              max="100"
              formControlName="noOfLossPercentageDecThree"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.noOfLossPercentageDecThree.touched || submitted) &&
              gamblingFormControl.noOfLossPercentageDecThree.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.noOfLossPercentageDecThree.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"> Deck4 : Gain Amount </label>
          </div>
          <div class="input-group col-8">
            <input class="form-control rb-input" placeholder="E.g." type="number" formControlName="noOfGainDecFour" />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.noOfGainDecFour.touched || submitted) && gamblingFormControl.noOfGainDecFour.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.noOfGainDecFour.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"> Deck4: Loss Amount </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="E.g. 100"
              type="number"
              formControlName="noOfLossDecFour"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.noOfLossDecFour.touched || submitted) && gamblingFormControl.noOfLossDecFour.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.noOfLossDecFour.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"> Deck4: Percentage of Loss </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="E.g. 100"
              min="0"
              max="100"
              type="number"
              formControlName="noOfLossPercentageDecFour"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.noOfLossPercentageDecFour.touched || submitted) &&
              gamblingFormControl.noOfLossPercentageDecFour.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.noOfLossPercentageDecFour.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1"> Maximum Game Duration in seconds </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="120"
              type="number"
              formControlName="maxGameDurationGambling"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (gamblingFormControl.maxGameDurationGambling.touched || submitted) &&
              gamblingFormControl.maxGameDurationGambling.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="gamblingFormControl.maxGameDurationGambling.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label class="text-black-1" translate>User groups</label>
          </div>
          <div class="col-8">
            <fui-multi-select
              [style]="{ width: '100%' }"
              class="selection"
              formControlName="groupIds"
              [options]="userGroupsOptins"
              labelField="name"
              valueField="uuid"
              [isSearchable]="true"
              [showCountText]="'Select'"
              #multiSelect
            >
              <fui-select-option *ngFor="let option of multiSelect.filteredOptions" [value]="option">
              </fui-select-option>
            </fui-multi-select>
            <div
              class="col-12 error-mssg"
              *ngIf="(gamblingFormControl.groupIds.touched || submitted) && gamblingFormControl.groupIds.errors"
            >
              <label for="isactive" class="text-danger" *ngIf="gamblingFormControl.groupIds.errors.required">
                *Please select user group.
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="isactive" class="text-black-1" translate>Cognitive status</label>
          </div>
          <div class="input-group col-8">
            <p-dropdown
              class="w-100-p"
              [options]="cognitiveStatus"
              optionLabel="name"
              optionValue="value"
              formControlName="isActive"
              placeholder="Select Cognitive status."
            ></p-dropdown>
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="(gamblingFormControl.isActive.touched || submitted) && gamblingFormControl.isActive.errors"
          >
            <label for="isactive" class="text-danger" *ngIf="gamblingFormControl.isActive.errors.required">
              *Please select survey status.
            </label>
          </div>
        </div>
      </form>
    </div>
    <div *ngIf="selectTestForm.get('testType').value === 'word-pair-test'">
      <form [formGroup]="wordPairsForm">
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Name</label>
          </div>
          <div class="input-group col-8">
            <input class="form-control rb-input" placeholder="Name" type="text" formControlName="cognitiveTestName" />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (wordPairsControl.cognitiveTestName.touched || submitted) && wordPairsControl.cognitiveTestName.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="wordPairsControl.cognitiveTestName.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Description</label>
          </div>
          <div class="input-group col-8">
            <textarea class="form-control" formControlName="cognitiveTestDescription" placeholder="Description">
            </textarea>
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (wordPairsControl.cognitiveTestDescription.touched || submitted) &&
              wordPairsControl.cognitiveTestDescription.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="wordPairsControl.cognitiveTestDescription.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <button type="button" class="btn-save ml-4 w-100" (click)="addSkills()">Add</button>
        <div formArrayName="wordPairs">
          <div *ngFor="let skill of wordPairs.controls; let i = index">
            <div class="row mt-3" [formGroupName]="i">
              <div class="col-4">
                <label for="first_name" class="text-black-1">Word A :</label>
              </div>
              <div class="input-group mt-3 col-8">
                <input class="form-control rb-input" placeholder="Word A" type="text" formControlName="wordA" />
              </div>
              <div
                class="col-12 error-mssg"
                *ngIf="(skill.get('wordA').touched || submitted) && skill.get('wordA').errors"
              >
                <label for="condition-answer-text" class="text-danger" *ngIf="skill.get('wordA').errors.required"
                  >*word A required.</label
                >
              </div>
              <div class="col-4 mt-3">
                <label for="first_name" class="text-black-1">Word B :</label>
              </div>
              <div class="input-group mt-3 col-8">
                <input class="form-control rb-input" placeholder="Word B" type="text" formControlName="wordB" />
              </div>
              <div
                class="col-12 error-mssg"
                *ngIf="(skill.get('wordA').touched || submitted) && skill.get('wordA').errors"
              >
                <label for="condition-answer-text" class="text-danger" *ngIf="skill.get('wordA').errors.required"
                  >*Pair of the word is required.</label
                >
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Duration to display each word pair in millisecond</label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="Duration to display each word pair in millisecond"
              type="number"
              formControlName="durationDisplayWords"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (wordPairsControl.durationDisplayWords.touched || submitted) &&
              wordPairsControl.durationDisplayWords.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="wordPairsControl.durationDisplayWords.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Duration for a user to answer in millisecond</label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="Duration for a user to answer in millisecond"
              type="number"
              formControlName="durationUserAnswer"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (wordPairsControl.durationUserAnswer.touched || submitted) && wordPairsControl.durationUserAnswer.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="wordPairsControl.durationUserAnswer.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Pass percentage</label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="Pass percentage"
              type="number"
              formControlName="passPercentage"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="(wordPairsControl.passPercentage.touched || submitted) && wordPairsControl.passPercentage.errors"
          >
            <label for="name" class="text-danger" *ngIf="wordPairsControl.passPercentage.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="first_name" class="text-black-1">Total number of rounds </label>
          </div>
          <div class="input-group col-8">
            <input
              class="form-control rb-input"
              placeholder="Total number of rounds "
              type="number"
              formControlName="totalNumberroundswordPair"
            />
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="
              (wordPairsControl.totalNumberroundswordPair.touched || submitted) &&
              wordPairsControl.totalNumberroundswordPair.errors
            "
          >
            <label for="name" class="text-danger" *ngIf="wordPairsControl.totalNumberroundswordPair.errors.required"
              >*Required.</label
            >
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label class="text-black-1" translate>User groups</label>
          </div>
          <div class="col-8">
            <fui-multi-select
              [style]="{ width: '100%' }"
              class="selection"
              formControlName="groupIds"
              [options]="userGroupsOptins"
              labelField="name"
              valueField="uuid"
              [isSearchable]="true"
              [showCountText]="'Select'"
              #multiSelect
            >
              <fui-select-option *ngFor="let option of multiSelect.filteredOptions" [value]="option">
              </fui-select-option>
            </fui-multi-select>
            <div
              class="col-12 error-mssg"
              *ngIf="(wordPairsControl.groupIds.touched || submitted) && wordPairsControl.groupIds.errors"
            >
              <label for="isactive" class="text-danger" *ngIf="wordPairsControl.groupIds.errors.required">
                *Please select user group.
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="isactive" class="text-black-1" translate>Cognitive status</label>
          </div>
          <div class="input-group col-8">
            <p-dropdown
              class="w-100-p"
              [options]="cognitiveStatus"
              optionLabel="name"
              optionValue="value"
              formControlName="isActive"
              placeholder="Select Cognitive status."
            ></p-dropdown>
          </div>
          <div
            class="col-12 error-mssg"
            *ngIf="(wordPairsControl.isActive.touched || submitted) && wordPairsControl.isActive.errors"
          >
            <label for="isactive" class="text-danger" *ngIf="wordPairsControl.isActive.errors.required">
              *Please select survey status.
            </label>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer border-0 rb-modal-footer">
    <button class="btn-cancel ml-4 w-100" (click)="activeModal.close(false)" ngbAutoFocus>Cancel</button>
    <button class="btn-save ml-4 w-100" *ngIf="!isLoading" (click)="save()">Submit</button>
    <button class="btn-save ml-4 w-100" disabled *ngIf="isLoading">
      <i class="fa fa-spinner fa-spin" style="font-size: 16px"></i>
    </button>
  </div>
</div>
